import { render, staticRenderFns } from "./ChoiceScreen.vue?vue&type=template&id=427e47e6"
import script from "./ChoiceScreen.vue?vue&type=script&lang=js"
export * from "./ChoiceScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports